module.exports = __webpack_public_path__ + "static/media/cc-light.bf51deb1.png";